"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyContext = void 0;
const types_1 = require("./types");
const stack_1 = require("./utils/stack");
const createEmptyRuntime = () => ({
    break: false,
    debuggerOn: true,
    isRunning: false,
    environments: [],
    typeEnv: [],
    value: undefined,
    nodes: [],
    stash: new stack_1.Stack(),
    agenda: new stack_1.Stack()
});
const createEmptyContext = (variant, externalSymbols, externalContext) => {
    return {
        externalSymbols,
        errors: [],
        externalContext,
        runtime: createEmptyRuntime(),
        numberOfOuterEnvironments: 1,
        prelude: null,
        executionMethod: 'auto',
        variant,
        unTypecheckedCode: [],
        previousCode: []
    };
};
exports.createEmptyContext = createEmptyContext;
const createContext = (variant = types_1.Variant.DEFAULT, externalSymbols = [], externalContext) => {
    const context = (0, exports.createEmptyContext)(variant, externalSymbols, externalContext);
    return context;
};
exports.default = createContext;
//# sourceMappingURL=createContext.js.map